<template>
  <div>
    <div class="breadcrumb-box">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item back">
            <a href="#" @click="$router.go(-1)">Back</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#" @click="$router.go(-1)">Driver List</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Create Driver
          </li>
        </ol>
      </nav>
    </div>

    <div class="form-box mt-3">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="form-box__title">Data Driver</h2>
      </div>
      <div class="mt-3">
        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">Region</label></div>
          <div class="col-lg-4">
            <div
              class="form-check form-check-inline"
              v-for="(option, index) in regions"
              :id="'inputRadioRegion' + item"
              :key="index"
            >
              <input
                type="radio"
                class="form-check-input"
                :value="option"
                v-model="form.region"
                @input="validateRequired"
              />
              <label class="form-check-label" :for="'inputRadioRegion' + item">
                {{ option }}
              </label>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3">
            <label class="form-label">Ekspedisi</label>
          </div>
          <div class="col-lg-4">
            <multiselect
              v-model="form.ekspedisi"
              :options="ekspedisiOptions"
              label="kode"
              track-by="id"
              placeholder="Select Ekspedisi"
            ></multiselect>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">Nama</label></div>
          <div class="col-lg-4">
            <input
              type="text"
              class="form-control"
              v-model="form.name"
              placeholder="Nama Driver"
              @input="validateRequired"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">No. HP</label></div>
          <div class="col-lg-4">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': !isValidPhoneNumber }"
              v-model="form.phone_no"
              placeholder="No. HP"
              @input="validatePhoneNumber"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">Email</label></div>
          <div class="col-lg-4">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': !isValidEmail }"
              v-model="form.email"
              placeholder="Email"
              @input="validateEmail"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">No. KTP</label></div>
          <div class="col-lg-4">
            <input
              type="text"
              class="form-control"
              v-model="form.ktp_no"
              :class="{ 'is-invalid': !isValidKtpNo }"
              placeholder="No. KTP"
              @input="validateKtpNo"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-3"><label class="form-label">No. SIM</label></div>
          <div class="col-lg-4">
            <input
              type="text"
              class="form-control"
              v-model="form.license_no"
              :class="{ 'is-invalid': !isValidLicenseNo }"
              placeholder="No. SIM"
              @input="validateLicenseNo"
            />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button
            type="button"
            class="btn btn-submit"
            :disabled="!isAllRequired"
            @click="submitForm()"
          >
            Selanjutnya
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  metaInfo: {
    title: "Create Driver",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      ekspedisiOptions: this.$store.getters.getEkspedisi.filter(
        (val) => val.kode !== "All"
      ),
      // phoneNoError: false,
      selectedNopol: null,
      filter: {
        start: startDate,
        end: currentDate,
        truck: null,
        region: null,
        plant: null,
      },
      form: {
        ekspedisi: null, // Initialize ekspedisi with null
        region: "",
        name: "",
        email: "",
        ktp_no: "",
        license_no: "",
        phone_no: "",
      },
      regions: ["M2Z", "M3Z"],
      isValidPhoneNumber: true,
      isValidKtpNo: true,
      isValidEmail: true,
      isValidLicenseNo: true,
      isAllRequired: false,
    };
  },
  components: {
    Multiselect,
  },
  watch: {
    "form.name"() {
      this.form.name = this.form.name.toUpperCase();
    },
  },
  methods: {
    validateRequired() {
      if (
        this.form.region &&
        this.form.name &&
        this.form.phone_no &&
        this.form.email &&
        this.form.ktp_no &&
        this.form.license_no &&
        this.isValidPhoneNumber &&
        this.isValidKtpNo &&
        this.isValidLicenseNo &&
        this.isValidEmail
      ) {
        this.isAllRequired = true;
      } else {
        this.isAllRequired = false;
      }
    },

    validatePhoneNumber() {
      this.form.phone_no = this.form.phone_no.replace(/[^0-9]/g, "");
      const phoneRegex = /^\d{10,16}$/;
      this.isValidPhoneNumber = phoneRegex.test(this.form.phone_no);
      this.validateRequired();
    },

    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailRegex.test(this.form.email);
      this.validateRequired();
    },

    validateKtpNo() {
      this.form.ktp_no = this.form.ktp_no.replace(/[^0-9]/g, "");
      const ktpNoRegex = /^\d{16}$/;
      this.isValidKtpNo = ktpNoRegex.test(this.form.ktp_no);
      this.validateRequired();
    },

    validateLicenseNo() {
      this.form.license_no = this.form.license_no.replace(/[^0-9]/g, "");
      const licensenNoRegex = /^\d{14}$/;
      this.isValidLicenseNo = licensenNoRegex.test(this.form.license_no);
      this.validateRequired();
    },

    goBack() {
      this.$router.go(-1); // Go back to the previous route
    },

    submitForm() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You are about to make a new data",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Simpan",
        })
        .then((result) => {
          if (result.value) {
            // Only send the 'id' of the selected ekspedisi
            const requestData = {
              ...this.form,
              ekspedisi: this.form.ekspedisi ? this.form.ekspedisi.id : null,
            };

            this.$http
              .post("/api/driver/save", requestData)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: "Tambah driver berhasil disimpan",
                });
                this.$router.go(-1); // Go back to the previous route
              })
              .catch((error) => {
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: error.response.data.message,
                });
              });
          }
        });
    },
  },
};
</script>
